var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService, SFUN } from '../../services/common.service';
import { ExpedienteService } from '../../services/expediente.service';
import { KeycloakService } from '../../services/keycloak.service';
var FavoritosComponent = (function () {
    function FavoritosComponent(_service, _expService, route) {
        this._service = _service;
        this._expService = _expService;
        this.route = route;
        this.busquedavisible = false;
        this.searchFilter = { descripcion: "", codigo: "", categoria: "", materia: "", activa: true, eliminados: false, accion: 0 };
        this.permisoFilter = false;
        this.filterDefault = '';
    }
    FavoritosComponent.prototype.ngOnInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.setPermisos(true);
            if (_this.permisoFilter) {
                _this._service.emitBlocking(true);
                _this.findAcciones();
            }
            else {
                _this.findFavoritos();
            }
        }, 2000);
    };
    FavoritosComponent.prototype.setPermisos = function (val) {
        if (typeof (KeycloakService.usr) !== 'undefined' && typeof (KeycloakService.usr.permisos) !== 'undefined') {
            this.permisoFilter = this._service.tienePermiso(SFUN.FavFilter);
        }
    };
    FavoritosComponent.prototype.setAccDefault = function () {
        this.filterDefault = this._service.getConfiguracion('FAVNOVFIL');
        if (this.filterDefault === null || this.filterDefault === '') {
            this.searchFilter.accion = 0;
        }
        else {
            this.searchFilter.accion = Number(this.filterDefault);
        }
        this.findFavoritos();
    };
    FavoritosComponent.prototype.findAcciones = function () {
        var _this = this;
        //console.log("find acciones");
        this._expService.findAcciones().subscribe(function (response) {
            _this.accionList = response;
            _this.searchFilter.accion = 0;
            _this.setAccDefault();
            _this._service.emitBlocking(false);
        });
    };
    FavoritosComponent.prototype.searchAction = function (query) {
        //console.log("search@html: " + query);
    };
    FavoritosComponent.prototype.limpiar = function () {
        this.searchFilter = { descripcion: "", codigo: "", categoria: "", materia: "", activa: true, eliminados: false, accion: 0 };
    };
    FavoritosComponent.prototype.buscar = function () {
        //console.log(JSON.stringify(this.searchFilter));
    };
    FavoritosComponent.prototype.ngOnDestroy = function () {
        // prevent memory leak when component is destroyed
    };
    FavoritosComponent.prototype.cargarMasFavoritos = function () {
        var _this = this;
        if (this.permisoFilter) {
            this._expService.findFavoritosByAcc(KeycloakService.getLoggedUser(), this.favoritos.page + 1, this.favoritos.size, this.searchFilter.accion.toString()).subscribe(function (response) {
                _this.favoritos = response;
                _this.favoritos.data.forEach(function (element) {
                    _this.dataShowing.push(element);
                });
                _this.showing = _this.dataShowing.length;
                //console.log(this.dataShowing);
            });
        }
        else {
            this._expService.findFavoritos(KeycloakService.getLoggedUser(), this.favoritos.page + 1, this.favoritos.size).subscribe(function (response) {
                _this.favoritos = response;
                _this.favoritos.data.forEach(function (element) {
                    _this.dataShowing.push(element);
                });
                _this.showing = _this.dataShowing.length;
                //console.log(this.dataShowing);
            });
        }
    };
    FavoritosComponent.prototype.onChangeSelectAcc = function (newValue) {
        this.searchFilter.accion = newValue;
    };
    FavoritosComponent.prototype.onClickSearch = function () {
        //console.log(JSON.stringify(this.searchFilter));
        this._service.emitBlocking(true);
        this.findFavoritos();
    };
    FavoritosComponent.prototype.findFavoritos = function () {
        var _this = this;
        //console.log("findFavoritos");
        if (this.permisoFilter) {
            this._expService.findFavoritosByAcc(KeycloakService.getLoggedUser(), 0, 5, this.searchFilter.accion.toString()).subscribe(function (response) {
                _this.favoritos = response;
                _this.dataShowing = _this.favoritos.data;
                _this.showing = _this.dataShowing.length;
                _this._service.emitBlocking(false);
            });
        }
        else {
            this._expService.findFavoritos(KeycloakService.getLoggedUser()).subscribe(function (response) {
                _this.favoritos = response;
                _this.dataShowing = _this.favoritos.data;
                _this.showing = _this.dataShowing.length;
                _this._service.emitBlocking(false);
            });
        }
    };
    return FavoritosComponent;
}());
FavoritosComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'my-app',
        templateUrl: 'favoritos.component.html'
    }),
    __metadata("design:paramtypes", [CommonService, ExpedienteService, ActivatedRoute])
], FavoritosComponent);
export { FavoritosComponent };
//# sourceMappingURL=favoritos.component.js.map